"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SendButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const colors_1 = require("../../common/colors");
function SendButton({ disabled, sendAction }) {
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: sendAction, disabled: disabled, children: (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { colors: disabled
                ? [colors_1.Colors.NEUTRAL_100, colors_1.Colors.NEUTRAL_100]
                : colors_1.Colors.GRADIENT, end: { x: 0, y: 1 }, style: styles.container, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowUp, size: 20, color: colors_1.Colors.NEUTRAL_00 }) }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        padding: 14,
        borderRadius: 28,
    },
});
